import { Button, Space } from 'antd';
import { DashboardOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { SiteSettings } from '@store/slices/settingsSlice.tsx';
import { getImageUrl } from '@tools/utils/imageUtils.tsx';
import './PublicSiteConstructionPage.css';

const CONSTRUCTION_IMAGE = '/assets/agente_en_construccion.png';

interface Props {
  site: SiteSettings | null;
  isStaff: boolean;
  isEshop: boolean;
  onPreview: () => void;
}

const PublicSiteConstructionPage = ({ site, isStaff, isEshop, onPreview }: Props) => {
  const navigate = useNavigate();
  const logoUrl = site?.logo ? getImageUrl(site.logo).srcDefault : null;
  const siteName = site?.name?.trim() || 'Sitio público';

  return (
    <main className="public-site-construction" aria-labelledby="public-site-construction-title">
      <div className="public-site-construction__content">
        {logoUrl ? (
          <img className="public-site-construction__logo" src={logoUrl} alt={`Logo de ${siteName}`} />
        ) : null}
        <p className="public-site-construction__site-name">{siteName}</p>
        <h1 id="public-site-construction-title">En Construcción</h1>
        <img
          className="public-site-construction__image"
          src={CONSTRUCTION_IMAGE}
          alt="Persona trabajando en la construcción del sitio"
        />
        {isStaff ? (
          <Space wrap size={12} className="public-site-construction__actions">
            <Button type="primary" icon={<EyeOutlined />} onClick={onPreview}>
              Preview
            </Button>
            {isEshop ? (
              <Button icon={<DashboardOutlined />} onClick={() => navigate('/eshop/dashboard')}>
                Ir a Dashboard
              </Button>
            ) : null}
          </Space>
        ) : null}
      </div>
    </main>
  );
};

export default PublicSiteConstructionPage;
